"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureTogglesProvider = void 0;
var _react = require("react");
var _contexts = require("../contexts");
var _jsxRuntime = require("react/jsx-runtime");
const FeatureTogglesProvider = exports.FeatureTogglesProvider = /*#__PURE__*/(0, _react.memo)(({
  toggles,
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.featureTogglesContext.Provider, {
  value: toggles,
  children: children
}));
